<template>
  <div
    class="sb-actions-menu"
    :class="activeClasses"
    data-testid="sb-data-table-actions-menu"
  >
    <span
      class="sb-actions-menu__rows-selected"
      data-testid="sb-data-table-action__selected-items"
      >{{ labelselectedItemsLength }}</span
    >
    <SbButton
      size="small"
      :label="cancelButtonLabel"
      variant="secondary"
      is-clear
      class="sb-actions-menu__btn-cancel"
      data-testid="sb-data-table-action__clear"
      @click="$emit('cancel')"
    />
    <component
      :is="isOnDesktop ? 'SbButton' : 'SbIconButton'"
      v-for="action in actions"
      :key="action.value"
      :label="action.label"
      variant="secondary"
      v-tooltip="disabledTooltip(action)"
      is-clear
      size="small"
      :icon="action.icon"
      :is-disabled="action.disabled"
      :is-loading="action.isLoading"
      :data-testid="`sb-data-table-action__${action.value}`"
      @click="() => $emit('click', action.value)"
    />
  </div>
</template>

<script lang="ts">
import SbButton from '../../Button'
import SbIconButton from '../../IconButton'
import { Tooltip } from '../../../directives'
import { WindowResizeObserverMixin } from '../../../mixins'
import sharedProps from '../sharedProps'
import i18n from '../../../i18n/index'

export default {
  name: 'SbDataTableActions',

  components: {
    SbButton,
    SbIconButton,
  },

  directives: {
    tooltip: Tooltip,
  },

  mixins: [WindowResizeObserverMixin()],

  props: {
    actions: sharedProps.actions,
    hideLabelActionsBreakpoint: sharedProps.hideLabelActionsBreakpoint,
    selectedRows: sharedProps.selectedItems,
    sticky: sharedProps.stickyMenu,
    locale: {
      type: String,
      default: 'en',
    },
  },

  emits: ['cancel', 'click'],

  computed: {
    activeClasses() {
      return {
        'sb-actions-menu--sticky': this.sticky,
      }
    },
    labelselectedItemsLength() {
      const labelItem = this.selectedItemsLength > 1 ? 'items' : 'item'
      return `${this.selectedItemsLength} ${labelItem} selected`
    },
    selectedItemsLength() {
      return this.selectedRows.length
    },
    cancelButtonLabel() {
      return i18n(this.locale, 'Cancel')
    },
  },

  methods: {
    disabledTooltip(action: unknown) {
      const isDisabled = action.disabled
      return {
        label: isDisabled ? action.disabledText : action.label,
        variant: isDisabled ? 'light' : 'dark',
        position: 'bottom',
        show: isDisabled || !this.isOnDesktop,
      }
    },
  },
}
</script>
